var map = {
	"./ar-SA.json": 68732,
	"./en-GB.json": 10277,
	"./es-MX.json": 86800,
	"./fr-FR.json": 90477,
	"./ko-KR.json": 98954,
	"./pt-BR.json": 42949,
	"./tl-PH.json": 88329,
	"./vi-VN.json": 6174,
	"./zh-CN.json": 52338,
	"./zh-TW.json": 70182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90901;